module.exports = __webpack_public_path__ + "img/guangshanruiduLeft.9a9d03b8.png";